import { Sort } from '@angular/material/sort';
import { ModuleUser } from '../../module-user/models/module-user.model';

export class SetMyUppcomingModules {
    static readonly type = '[MyUppcomingModules] SetMyUppcomingModules';

    constructor(public payload: ModuleUser[]) {}
}

export class UnsetMyUppcomingModules {
    static readonly type = '[MyUppcomingModules] UnsetMyUppcomingModules';
}

export class AddMyUppcomingModules {
    static readonly type = '[MyUppcomingModules] AddMyUppcomingModules';

    constructor(public payload: ModuleUser[]) {}
}

export class FetchMyUppcomingModule {
    static readonly type = '[MyUppcomingModules] FetchMyUppcomingModule';

    constructor(public payload: string) {}
}

export class FetchMyUppcomingModules {
    static readonly type = '[MyUppcomingModules] FetchMyUppcomingModules';

    constructor(
        public payload?: {
            category: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            isUppcoming?: boolean;
            participantId?: string;
            tag?: number[];
        }
    ) {}
}

export class FetchMyUppcomingModulesSuccess {
    static readonly type = '[MyUppcomingModules] FetchMyUppcomingModulesSuccess';
}

export class FetchMyUppcomingModulesFailure {
    static readonly type = '[MyUppcomingModules] FetchMyUppcomingModulesFailure';
}

export class ToggleSelectedModule {
    static readonly type = '[MyUppcomingModules] ToggleSelectedModule';

    constructor(public payload: string) {}
}

export class SelectFilteredModules {
    static readonly type = '[MyUppcomingModules] SelectFilteredModules';
}

export class DeselectSelectedModules {
    static readonly type = '[MyUppcomingModules] DeselectSelectedModules';
}

export class SearchMyUppcomingModules {
    static readonly type = '[MyUppcomingModules] SearchMyUppcomingModules';

    constructor(public payload: string) {}
}

export class SortMyUppcomingModules {
    static readonly type = '[MyUppcomingModules] SetMyUppcomingModulesSort';

    constructor(public payload: Sort) {}
}
